import classNames from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../components/Modal/useModal';
import { capitalize } from '../../../core/helpers';
import { useTabs } from '../../../hooks';
import './SalesMetrics.scss';
import SalesMetricsModal from './SalesMetricsModal';

const TABS = ['all', 'amazon.de', 'amazon.es', 'amazon.pl', 'amazon.uk'];

const METRICS: SalesMetric[] = [
  {
    value: '3,3%',
    title: 'Conversion Rate',
  },
  {
    value: '23%',
    title: 'Return rate',
  },
  {
    value: '980',
    title: 'Inventory Performance Index',
  },
  {
    value: '1.4%',
    title: 'Order Defect Rate (ODR)',
    valueClassName: 'Text--red',
  },
  {
    value: '2.5%',
    title: 'Pre-Fulfillment Cancel Rate (PFCR)',
    valueClassName: 'Text--orange',
  },
];

export interface SalesMetric {
  value: string;
  title: string;
  valueClassName?: string;
}

export default function SalesMetrics() {
  const { activeTab, onClickTab } = useTabs<string>('all');
  const [modalData, setModalData] = useState<SalesMetric>({
    title: '',
    value: '',
    valueClassName: '',
  });

  const { t } = useTranslation();

  const { isModalOpened, closeModal, openModal } = useModal();

  return (
    <div className='SalesMetrics'>
      <div className='fw-800 mb-2'>{t('Metrics')}</div>
      <div className='row row-cols-auto gx-3 mb-3'>
        {TABS.map((tab) => (
          <div className='col' key={tab}>
            <button
              className={classNames('SalesMetrics__tab border-0 px-2 py-0', {
                'SalesMetrics__tab--active': activeTab === tab,
              })}
              onClick={onClickTab(tab)}
            >
              {t(capitalize(tab))}
            </button>
          </div>
        ))}
      </div>
      <div className='row gx-2 mx-0 w-100'>
        {METRICS.map(({ title, value, valueClassName }) => (
          <div
            className='col pt-2 SalesMetrics__box px-2 pb-3 rounded cursor-pointer'
            key={value}
            onClick={() => {
              setModalData({
                title,
                value,
                valueClassName,
              });
              openModal();
            }}
          >
            <div
              className={`SalesMetrics__title fw-900 ${valueClassName || ''}`}
              style={{
                marginBottom: 2,
              }}
            >
              {value}
            </div>
            <div className='multiline Text--gray'>{t(title)}</div>
          </div>
        ))}
      </div>
      <SalesMetricsModal
        isModalOpened={isModalOpened}
        closeModal={closeModal}
        data={modalData}
      />
    </div>
  );
}
